<div class="h-full flex flex-col gap-2 z-0 relative p-2 lg:pl-0">
   
  <div class="py-2 border-b border-zinc-950/10 dark:border-white/10 flex flex-wrap justify-between items-center gap-4">
     <h3 class="text-lg font-medium leading-6 text-main-dark">
      Notifications
    </h3>
    <div *ngIf="notifications && notifications.length" class="flex items-center gap-3">
      <h1 class="text-xs text-nowrap text-left">Showing {{(50 * currentPage) - (notifications.length != 50? (50
        -notifications.length) : 0) }} of {{totalResults }} entries
      </h1>
      <button *ngIf="hasUnreadNotifications()"
        type="button"
        (click)="onMarkAllAsRead()"
        class="text-xs font-medium text-blue-600 hover:text-blue-700 dark:text-blue-400 hover:underline cursor-pointer transition-colors">
        Mark all as read
      </button>
    </div>
      <div class="flex flex-wrap items-center gap-2">
      <button *ngFor="let tab of categoryTabs" type="button" (click)="onSelectCategory(tab.value)"
        [ngClass]="category === tab.value ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'">
        {{tab.label}}
      </button>
    </div>
    <div class="flex flex-wrap items-center gap-2">
      <!-- Datepicker -->
      <div class="relative flex-shrink w-full sm:w-56">
        
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" aria-hidden="true">
          <svg class="h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z" />
          </svg>
        </div>

        <div class="relative">
          <input type="text" class="form-control" [(ngModel)]="searchDate" (ngModelChange)="onSearchDateChange($event)"
            placeholder="Select Date" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2" [readonly]="true"
            [selectMode]="'range'" />
          <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
        </div>

      </div>
      <!-- Search Input -->
       <div class="relative w-full sm:w-56">
        <!-- Heroicon name: mini/magnifying-glass -->
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="absolute z-50 left-2 top-1/2 transform -translate-y-1/2 size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
        <input type="text" name="search" id="search" class="pl-9" placeholder="Search" [(ngModel)]="search"
          autocomplete="off" />
      </div>

    </div>
   
  
  </div>
  <div *ngIf="notifications && notifications.length" role="list"
    class="h-full overflow-hidden flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
    <ul class="overflow-y-auto h-full w-full p-2 divide-y divide-zinc-950/10 dark:divide-white/10">
      <li
        *ngFor="let notification of notifications | filter:search | paginate: { itemsPerPage: numberOfRecords, currentPage: currentPage, totalItems:totalResults };">
        <button type="button" (click)="(notification.type === 'trip' && validStatuses.includes(notification?.trip?.status)) || notification.member || (notification.type === 'support' && notification.metadata?.url) ? onNotificationClick(notification) : null"
          class="flex w-full items-start gap-3 rounded-lg border p-3 text-left transition-all duration-150 hover:shadow-sm"
          [ngClass]="notification.isRead
            ? 'border-zinc-200/80 bg-zinc-50/50 hover:bg-zinc-100/70 dark:border-zinc-800/80 dark:bg-zinc-900/40 dark:hover:bg-zinc-900/80'
            : 'border-l-4 border-l-blue-600 border-blue-200/80 bg-blue-50/80 hover:bg-blue-100/70 shadow-sm dark:border-l-blue-500 dark:border-blue-900/60 dark:bg-blue-950/40 dark:hover:bg-blue-950/70'">
          <div class="min-w-0 flex-1">
            <div class="flex items-start justify-between gap-2">
              <div class="flex min-w-0 items-center gap-2">
                <p class="truncate text-sm"
                  [ngClass]="notification.isRead ? 'font-medium text-zinc-600 dark:text-zinc-400' : 'font-semibold text-zinc-950 dark:text-white'">
                  {{ notification.title | titlecase }}
                </p>
                <span *ngIf="notification.company" class="badge-secondary dark:badge-primary shrink-0">
                  {{ notification.company?.name }}
                </span>
              </div>
              <div class="flex items-center gap-1.5 shrink-0">
                <span *ngIf="!notification.isRead"
                  class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-blue-100 text-blue-700 dark:bg-blue-900/60 dark:text-blue-300">
                  <span class="size-1.5 rounded-full bg-blue-600 dark:bg-blue-400"></span>
                  New
                </span>
                <span *ngIf="notification.isRead"
                  class="inline-flex items-center text-[10px] font-medium text-zinc-400 dark:text-zinc-500">
                  Read
                </span>
              </div>
            </div>
            <p class="mt-1 text-xs"
              [ngClass]="notification.isRead ? 'text-zinc-500 dark:text-zinc-400' : 'text-zinc-700 dark:text-zinc-200 font-medium'">
              {{ notification.message }}
            </p>
            <p class="mt-1.5 text-[11px]"
              [ngClass]="notification.isRead ? 'text-zinc-400 dark:text-zinc-500' : 'text-blue-600 dark:text-blue-400 font-medium'">
              {{ getRelativeTime(notification.createdAt) }} &middot; {{ notification.createdAt | date:'MM/dd/yyyy HH:mm' }}
            </p>
          </div>
        </button>
      </li>
    </ul>
    <div class="flex justify-end">
      <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
    </div>
  </div>
  <div *ngIf="!notifications.length">
    <div
      class="relative block w-full rounded-lg border-2 border-dashed border-zinc-950/10 dark:border-white/10 p-12 text-center">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="mx-auto h-12 w-12 text-main-light">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M3 8.25V18a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 18V8.25m-18 0V6a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 6v2.25m-18 0h18M5.25 6h.008v.008H5.25V6zM7.5 6h.008v.008H7.5V6zm2.25 0h.008v.008H9.75V6z" />
      </svg>
      <span class="mt-2 block font-medium text-main-dark">No notifications to show</span>
    </div>
  </div>
</div>